import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService, TranslationService } from '@dch/ng-common';

@Injectable()
export class BillingBackToPreviousScreenService {
  constructor(
    private router: Router,
    private environmentService: EnvironmentService,
    private translationService: TranslationService
  ) {}

  goBack(shouldGoBackToOverview = false) {
    if (shouldGoBackToOverview) {
      this.router.navigate(['/overview']);
    } else if (this.environmentService.isMyproximusMobileApp) {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        location.assign(
          this.translationService.getTranslatedValueFor(
            'bills.callDetails.backToNativeUrl'
          )
        );
      }
    } else if (this.environmentService.isMillennialsMobileApp) {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        location.assign(
          this.translationService.getTranslatedValueFor(
            'bills.callDetails.backToNativeMillennialsUrl'
          )
        );
      }
    } else if (this.environmentService.isProximusPlusMobileApp) {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        location.assign(
          this.translationService.getTranslatedValueFor(
            'bills.callDetails.backToNativeUrlProximusPlus'
          )
        );
      }
    } else if (window.history.length > 1) {
      window.history.back();
    } else {
      this.router.navigate(['/overview']);
    }
  }
}
